import { EmployeeRole } from '@makemydeal/dr-platform-types';
import { roleCarriesData } from '@makemydeal/dr-dash-store/utils/employeeDetailsUtils';
import type { EmployeeDetailsSupportedRoles, EmployeeTeam } from '@makemydeal/dr-dash-types';

export const alwaysVisibleRoleTitleMap: Record<string, string> = {
    [EmployeeRole.PrimarySalesperson]: 'Primary Salesperson',
    [EmployeeRole.SalesManager]: 'Sales Manager',
    [EmployeeRole.FIManager]: 'Finance Manager'
};

export const additionalRoleTitleMap: Record<string, string> = {
    [EmployeeRole.SecondarySalesperson]: 'Secondary Salesperson',
    [EmployeeRole.OtherSalesperson]: 'Other Salesperson',
    [EmployeeRole.AsstSalesManager]: 'Assistant Sales Manager',
    [EmployeeRole.Closer]: 'Closer',
    [EmployeeRole.CustomerService]: 'Customer Service',
    [EmployeeRole.AftermarketManager]: 'Aftermarket Manager',
    [EmployeeRole.DeliveryManager]: 'Delivery Manager',
    [EmployeeRole.Other]: 'Other'
};

export const legacyRoleTitleMap: Record<string, string> = {
    [EmployeeRole.PrimarySalesperson]: 'Primary Salesperson',
    [EmployeeRole.SalesManager]: 'Sales Manager',
    [EmployeeRole.FIManager]: 'Finance Manager',
    [EmployeeRole.SecondarySalesperson]: 'Secondary Salesperson'
};

export const roleFieldKeys = (role: string): string[] => [`${role}-firstName`, `${role}-lastName`, `${role}-employeeDmsId`];

export const getAdditionalRolesWithData = (team: EmployeeTeam): EmployeeDetailsSupportedRoles[] =>
    (Object.keys(additionalRoleTitleMap) as EmployeeDetailsSupportedRoles[]).filter((role) => roleCarriesData(team[role]));

export const mapRoleForSearch = (role: string): string => {
    if (role === EmployeeRole.PrimarySalesperson || role === EmployeeRole.SecondarySalesperson) {
        return 'Salesperson';
    }
    if (role === EmployeeRole.FIManager) {
        return 'FIManager';
    }
    if (role === EmployeeRole.SalesManager) {
        return 'SalesManager';
    }
    return role;
};
